export default __webpack_public_path__ + "static/media/empty_heart.4fce3fad.png";